module.exports = __webpack_public_path__ + "img/horizontal_7_4_pp12_9005.5387a7d4.png";